import { minutesToMilliseconds } from "date-fns";

export const DEDUPING_INTERVAL = minutesToMilliseconds(1);
export const POLL_INTERVAL = minutesToMilliseconds(1);

export const DEFAULT_PER_PAGE = 10;
